import React, {FC} from 'react';

import {useLocalize} from '../../../../libs/shared/core/src/helpers/internationalization/internationalizationContext';
import {RecipientRolesEnum} from '../../../../libs/shared/core/src/models/api/recipientModel';
import {formatRecipientRole} from '../../../helpers/models/recipientHelpers';

/*
 * Props.
 */

interface RecipientRoleFormatterProps {
  role: RecipientRolesEnum;
}

/*
 * Component.
 */

export const RecipientRoleFormatter: FC<RecipientRoleFormatterProps> = (props) => {
  const localize = useLocalize();
  return <>{formatRecipientRole(localize, props.role)}</>;
};
